import React from 'react';

import Chart from 'react-apexcharts';

const COLOR_PALETTE = ['#27B6FF', '#21005C'];
const CHART_OPTIONS = {
    chart: {
        fontFamily: 'var(--font-sans)',
        type: 'bar',
        width: '100%',
        stacked: false,
        toolbar: {
            tools: {
                download: false,
                pan: false,
                reset: false,
                selection: false,
                zoom: false,
            },
        },
    },
    tooltip: {
        y: {},
    },
    colors: COLOR_PALETTE,
    xaxis: {
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        categories: ['PR', 'EA'],
    },
    yaxis: {
        opposite: false,
        axisBorder: {
            show: false,
        },
        axisTicks: {
            show: false,
        },
        labels: {
            show: false,
        },
    },
    legend: {
        show: false,
    },
    plotOptions: {
        bar: {
            columnWidth: '50%',
            distributed: true,
            dataLabels: {
                position: 'bottom',
            },
        },
    },
    dataLabels: {
        enabled: true,
    },
};

export default function ProcurementColumnChart(props) {
    if (!props.data?.length) {
        return <div className="text-info">{$t('No data provided')}</div>;
    }

    return (
        <div className="card border-0 rounded-15px bg-white shadow tw-h-full tw-w-full">
            <div className="card-body card-widget dashboard__header_box">
                <h5 className="text-dark-blue pt-2">{props.title}</h5>
                <Chart options={{ ...CHART_OPTIONS }} series={[{ name: props.title, data: props.data }]} type={'bar'} height={200} />
            </div>
        </div>
    );
}
